
import { defineComponent } from 'vue'
import CardComponent from './components/CardComponent.vue'

export default defineComponent({
    name: 'App',

    components: {
        'card-component': CardComponent,
    },

    created() {
        return (document.title = '#01 - NFT Card Component')
    },
})
